<template lang="pug">
    div
        filters
            slot(slot="statistics")
                base-statistics
                    slot(slot="total")
                        span {{ promotions.total ? promotions.total : 0 }}
            slot(slot="filters")
                input.border.caret-inherit.pl-2.pr-2.h-10(type="text" v-model="search" placeholder="название акции")
                select-option.w-150(
                    name="active"
                    :options="statusOptions"
                    predefined="Все статусы"
                    @value="onStatus"
                )
                select-option.w-250(
                    name="sort"
                    :options="sortOptions"
                    predefined="По дате добавления"
                    @value="onSort"
                )
                template(v-if="seesAllGroups")
                    select-option.w-150(
                        name="group"
                        :options="USER_GROUPS"
                        :predefined="USER_GROUPS[0].name"
                        @value="onGroup"
                    )
            slot(slot="buttons")
                promotion-form(ref="form" @saved="onSaved")
        promotions-list(ref="table" :filters="filters" @edit="onEdit")
</template>

<script>
import Filters from '@/components/common/filters';
import BaseStatistics from '@/components/common/filters/base-statistics';
import SelectOption from '@/components/common/forms/select-option';
import PromotionsList from '@/components/views/promotions/';
import PromotionForm from '@/components/views/promotions/promotion-form';
import { USER_GROUPS } from '@/configs/user-groups';
import { PromotionsNameSpace, PromotionsGetterTypes } from '@/store/promotions/types';
import { AuthorizationNameSpace, AuthorizationGetterTypes } from '@/store/authorization/types';

export default {
    name: "PromotionsListPage",
    components: {
        'filters': Filters,
        'base-statistics': BaseStatistics,
        'select-option': SelectOption,
        'promotions-list': PromotionsList,
        'promotion-form': PromotionForm,
    },
    data() {
        return {
            search: '',
            searchTimer: null,
            filters: {
                group: null,
                search: '',
                active: null,
                sort: 'created',
            },
            statusOptions: [
                { name: 'Все статусы', value: '' },
                { name: 'Активные', value: true },
                { name: 'Неактивные', value: false },
            ],
            sortOptions: [
                { name: 'По дате добавления', value: 'created' },
                { name: 'Активен до, сначала ранние', value: 'until_asc' },
                { name: 'Активен до, сначала поздние', value: 'until_desc' },
            ],
        }
    },
    computed: {
        promotions() {
            return this.$store.getters[`${PromotionsNameSpace}/${PromotionsGetterTypes.GetResponse}`] || { total: 0 }
        },
        USER_GROUPS() {
            return [
                {
                    name: 'Все группы',
                    value: '',
                    selected: true,
                    disabled: true,
                    hidden: true,
                },
                { name: 'Общая', value: 0 },
                ...USER_GROUPS.filter((group) => group.value !== 1),
            ]
        },
        userRole() {
            return Number(this.$store.getters[`${AuthorizationNameSpace}/${AuthorizationGetterTypes.GetRole}`])
        },
        seesAllGroups() {
            return this.userRole === 1 || this.userRole === 2 || this.userRole === 6
        },
    },
    methods: {
        patchFilters(patch) {
            this.filters = { ...this.filters, ...patch }
        },
        onGroup(val) {
            if (val === 'Все группы') {
                this.patchFilters({ group: null })
                return
            }
            const group = this.USER_GROUPS.find((item) => item.name === val)
            this.patchFilters({ group: group ? group.value : null })
        },
        onStatus(val) {
            const status = this.statusOptions.find((item) => item.name === val)
            this.patchFilters({ active: status ? status.value : null })
        },
        onSort(val) {
            const sort = this.sortOptions.find((item) => item.name === val)
            this.patchFilters({ sort: sort ? sort.value : 'created' })
        },
        onEdit(item) {
            this.$refs.form.open(item)
        },
        onSaved() {
            this.$refs.table.reload()
        },
    },
    watch: {
        search() {
            clearTimeout(this.searchTimer)
            this.searchTimer = setTimeout(() => {
                this.patchFilters({ search: this.search.trim() })
            }, 300)
        },
    },
    beforeDestroy() {
        clearTimeout(this.searchTimer)
    },
}
</script>
